// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2ff91de6","553":"c7b87d7f","977":"fb5854ae"}[chunkId] + ".chunk.js";
};